import { LazyLoadImage } from 'react-lazy-load-image-component';

import Button from '@r1-frontend/ui-react/components/buttons/button';
import { ButtonGroup } from '@r1-frontend/ui-react/components/buttons/buttonGroup/ButtonGroup';
import DefaultPopup from '@r1-frontend/ui-react/components/popups/defaultPopup';
import { H3 } from '@r1-frontend/ui-react/components/typography/heading';
import { Paragraph3 } from '@r1-frontend/ui-react/components/typography/paragraph';
import { IndentContainer, ListContainer } from '@r1-frontend/ui-react/experimental/containers';

import * as ST from './styled';

interface IProps {
    isOpen: boolean,
    onAgreement: () => void,
    onClosePopup: () => void,
}

export const MobileAppPopupComponent = ({ isOpen, onAgreement, onClosePopup }: IProps): JSX.Element =>
    <DefaultPopup
        isOpen={isOpen}
        onClose={onClosePopup}
        customStyles={{
            popup: {
                mobile: {
                    overflowY: 'visible',
                    width: '343px',
                    minWidth: '300px',
                },
            },
        }}
    >
        <ST.Image>
            <LazyLoadImage src={require('@static/images/mobileAppPopup/maskot.png')} alt='маскот' width='343px'/>
        </ST.Image>
        <IndentContainer $united={[24]}>
            <ListContainer $size={16}>
                <ListContainer $size={8}>
                    <H3 $withIndent={false}>Скачайте «Мой Дом.ру»</H3>
                    <Paragraph3>
                        В&nbsp;приложении ещё удобней проверять баланс и&nbsp;расходы,
                        настраивать тариф и&nbsp;услуги для себя, а&nbsp;ещё управлять несколькими договорами
                    </Paragraph3>
                </ListContainer>
                <ButtonGroup size={'large'}>
                    <Button onClick={onAgreement}>Скачать приложение</Button>
                    <Button onClick={onClosePopup} bType={'secondary'}>Продолжить на сайте</Button>
                </ButtonGroup>
            </ListContainer>
        </IndentContainer>
    </DefaultPopup>;

